import { render, staticRenderFns } from "./EmployeesForm.vue?vue&type=template&id=885e8a14&scoped=true"
import script from "./EmployeesForm.vue?vue&type=script&lang=js"
export * from "./EmployeesForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeesForm.vue?vue&type=style&index=0&id=885e8a14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885e8a14",
  null
  
)

export default component.exports